import { ICON_PATHS, type IconName } from '../../shared/icons.ts';

export { type IconName, itemIcon } from '../../shared/icons.ts';

// A small inline icon set (24-unit grid, 2px strokes, currentColor), so the
// app carries no icon dependency and every glyph inherits the text colour.
// Icons are decorative: the text or aria-label beside them carries meaning.

interface IconProps {
  readonly name: IconName;
  /** Size in CSS units; defaults to the surrounding text height. */
  readonly size?: string;
  readonly className?: string | undefined;
}

export function Icon({ name, size = '1.25em', className }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-icon={name}
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}
